<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/map#map">Map</a></p>
<p class="toc-bot"><a href="#/xhtml/char#char">Main Characters</a></p>
<p class="toc"><span class="epub-b"><a href="#/xhtml/part1#pt1">Part I: Sun Among Women</a></span></p>
<p class="toc">1. <a href="#/xhtml/chapter1#ch1">Blood in the Sand</a></p>
<p class="toc">2. <a href="#/xhtml/chapter2#ch2">The Assassin</a></p>
<p class="toc">3. <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">The Widow</span></p>
<p class="toc">4. <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">The Imperial Haram</span></p>
<p class="toc">5. <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">The Meena Bazaar</span></p>
<p class="toc">6. <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">The Executioner’s Sword</span></p>
<p class="toc">7. <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Absolution</span></p>
<p class="toc">8. <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">‘Light of the Palace’</span></p>
<p class="toc">9. <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Life and Death</span></p>
<p class="toc">10. <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">‘Lord of the World’</span></p>
<p class="toc">11. <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">The Red Velvet Coach</span></p>
<p class="toc">12. <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">The Poison Pen</span></p>
<p class="toc">13. <span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">The Abyssinian</span></p>
<p class="toc">14. <span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">The Enemy Within</span></p>
<p class="toc-bot">15. <span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">The Homecoming</span></p>
<p class="toc"><span class="epub-b"><span href="#/xhtml/part2#pt2" title="Link target outside of Sample">Part II: Outcasts</span></span></p>
<p class="toc">16. <span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Asirgarh</span></p>
<p class="toc">17. <span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">The Outlaw</span></p>
<p class="toc">18. <span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">The Kindness of Strangers</span></p>
<p class="toc">19. <span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">The Messenger</span></p>
<p class="toc">20. <span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">The Price</span></p>
<p class="toc">21. <span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">The Opportunist</span></p>
<p class="toc">22. <span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">River of Blood</span></p>
<p class="toc">23. <span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">A Parting of the Ways</span></p>
<p class="toc">24. <span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">The Funeral Cortège</span></p>
<p class="toc">25. <span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">The Sins of the Father</span></p>
<p class="toc-bot">26. <span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">The Peacock Throne</span></p>
<p class="toc"><span href="#/xhtml/note#note" title="Link target outside of Sample">Historical Note</span></p>
<p class="toc"><span href="#/xhtml/add#add" title="Link target outside of Sample">Additional Notes</span></p>
<p class="toc"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">Also by Alex Rutherford</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7752426f